module.exports = __webpack_public_path__ + "static/media/icon-city-ticket-tile~LFWJbMVh.325beb5d.svg";